import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format'
import { Col, Collapse, DatePicker, Row, Table, Tooltip } from 'antd';
import { get, groupBy } from 'lodash';
import moment from 'moment';

import { BaseReport } from '../components';
import NumberColor from './NumberColor';
import { lib, request } from 'src/Utils';
import submissionHelper from 'src/pages/DashboardApp/Submission/helper';
import readProductionJobs from './readProductionJobs';
import typeCodes from 'src/Utils/static/typeCodes';
import { CaretDownOutlined, CaretUpOutlined, InfoCircleOutlined } from '@ant-design/icons';
import CellInputDays from './InputDays';

class YearlyReport extends BaseReport {
  constructor(props) {
    super(props)

    window._submissionHelper = submissionHelper
    this.title = 'Yearly Report'
    // this.urlKey = 'office-working-sheet'
    this.rangeMessageError = 'Cannot display for more than 1 year'
    this._totalColumnsWidth = 0
    this.myProfile = lib.ls.getCurrentUser()

    console.log('constructor this.objParam', this.objParam, this.range_before, this.range_after)

    this.setRangeDate({
      start_date: this.objParam.start_date || moment().startOf('year').format(),
      end_date: this.objParam.end_date || moment().endOf('year').format(),
    })

    console.log('constructor 2', this.range_before, this.range_after)

    this.columns = [
      {
        title: 'Year',
        dataIndex: ['date'],
        width: 50,
        render: (val) => moment(val).format('YYYY'),
      },
      {
        title: 'Month',
        dataIndex: ['date'],
        width: 85,
        render: (val) => moment(val).format('MMMM'),
      },
      {
        title: 'Days',
        dataIndex: ['days'],
        width: 50,
        align: 'right',
        // render: (val) => val || '-',
        render: (val, record) => (
          <CellInputDays
            disabled={!this.myProfile.is_owner}
            date={record.date}
            daysProduction={record.days_production}
            value={val}
            onSave={(monthlyWorkDay) => {
              this.updateList(
                this.__list.map((item) => ({
                  ...item,
                  ...(item.date === monthlyWorkDay.date
                    ? this.getMappedRecord(monthlyWorkDay, record)
                    : item),
                }))
              )
            }}
          />
        ),
        // --------- summary ---------
        summaryKey: 'days',
        renderSummary: (total, dataSource) => {
          const avg = total / dataSource.length
            return avg
              ? Math.floor(avg * 10) / 10
              : '-'
        },
      },
      {
        title: 'TW Hours',
        children: [
          {
            title: 'Hours off',
            dataIndex: ['day_off'],
            align: 'right',
            width: 70,
            render: (val, record) => {
              if (!val) return '-'
              return (
                <Tooltip
                  mouseLeaveDelay={0}
                  title={!!record.overtime_day && (
                    <div>
                      <div>
                        Leave Days : {val + record.overtime_day} ({(val * 8) + (record.overtime_day * 8)} Hours)
                      </div>
                      <div>
                        Converted Overtimes : {record.overtime_day * 8} Hours 
                      </div>
                    </div>
                  )}
                >
                  <span className={record.overtime_day && 'link-blue'}>
                    <NumberFormat
                      thousandSeparator
                      displayType='text'
                      value={Number((val * 8).toFixed(2))}
                    />
                  </span>
                </Tooltip>
              )
            },
            // --------- summary ---------
            summaryKey: 'day_off',
            renderSummary: (total) => !total
              ? '-'
              : <Tooltip mouseLeaveDelay={0} title={submissionHelper._overtime.renderDuration(total * 8 * 60 * 60 * 1000)}>
                  <NumberFormat
                    thousandSeparator
                    displayType='text'
                    value={Number((total * 8).toFixed(2))}
                  />
                </Tooltip>,
          },
          {
            title: 'Target',
            dataIndex: ['target_hour'],
            align: 'right',
            width: 60,
            // render: (val) => val || '-',
            render: (val, record) => {
              if (!val) return '-'
              return (
                <Tooltip
                  mouseLeaveDelay={0}
                  title={!!record.day_off &&
                    `${Number(Number(val).toFixed(2))} = ${record.target_hour + (record.day_off * 8)} - ${record.day_off * 8}`}
                >
                  <span className={record.day_off && 'link-blue'}>
                    <NumberFormat
                      thousandSeparator
                      displayType='text'
                      value={Number(Number(val).toFixed(2))}
                    />
                  </span>
                </Tooltip>
              )
            },
            // --------- summary ---------
            summaryKey: 'target_hour',
            renderSummary: (total) => !Number(total) ? '-' : (
              <NumberFormat
                thousandSeparator
                displayType='text'
                value={Number(total.toFixed(2))}
              />
            ),
          },
          {
            title: 'Realization',
            dataIndex: ['ms'],
            align: 'right',
            width: 90,
            render: (val, record) => (
              <NumberColor
                target={record.target_hour}
                realization={Number(lib.time.getFloat(val))}
              />
            ),
            // --------- summary ---------
            summaryKey: 'ms',
            renderSummary: (total, _, summary) => !total ? '-' : (
              <NumberColor
                target={summary.target_hour}
                realization={Number(lib.time.getFloat(total))}
              />
            ),
          },
          {
            title: 'Delta hours',
            dataIndex: ['delta_hours'],
            align: 'right',
            width: 70,
            render: (val) => val
              ? Number(Number(val).toFixed(2))
              : '-',
            // --------- summary ---------
            summaryKey: 'delta_hours',
            renderSummary: (total) => total
              ? Number(Number(total).toFixed(2))
              : '-'
          },
        ],
      },
      {
        title: 'KPI',
        children: [
          {
            title: 'Target',
            dataIndex: ['target_kpi'],
            align: 'right',
            width: 60,
            // --------- summary ---------
            summaryKey: 'target_kpi',
            renderSummary: (total, dataSource) => {
              const avg = total / dataSource.length
                return avg
                  ? Math.floor(avg * 10) / 10
                  : '-'
            },
          },
          {
            title: 'Realization',
            dataIndex: ['kpi'],
            align: 'right',
            width: 90,
            render: (val, record) => (
              <NumberColor
                target={record.target_kpi}
                realization={val}
              />
            ),
            // --------- summary ---------
            summaryKey: 'kpi',
            renderSummary: (total, dataSource, summary) => {
              const avg = total / dataSource.length
              const targetAvg = summary.target_kpi / dataSource.length
              return (
                <NumberColor
                  target={targetAvg}
                  realization={avg}
                />
              )
            }
          },
        ],
      },
      {
        title: 'Point',
        children: [
          {
            title: 'Target',
            dataIndex: ['target_point'],
            align: 'right',
            width: 60,
            render: (val) => val ? val.toFixed(2) : '-',
            // --------- summary ---------
            summaryKey: 'target_point',
            renderSummary: (total) => !total ? '-' : (
              <NumberFormat
                thousandSeparator
                displayType='text'
                value={Number(total).toFixed(2)}
              />
            ),
          },
          {
            title: 'Realization',
            dataIndex: ['point'],
            align: 'right',
            width: 90,
            render: (val, record) => (
              <NumberColor
                target={record.target_point}
                realization={val}
              />
            ),
            // --------- summary ---------
            summaryKey: 'point',
            renderSummary: (total, _, summary) => !total ? '-' : (
              <NumberColor
                target={summary.target_point}
                realization={total}
              />
            ),
          },
        ],
      },
      {
        title: 'Area',
        children: [
          {
            title: 'Target',
            dataIndex: ['target_area'],
            align: 'right',
            width: 60,
            render: (val) => <NumberColor realization={val} />,
            // --------- summary ---------
            summaryKey: 'target_area',
            renderSummary: (total) => !total ? '-' : (
              <NumberFormat
                thousandSeparator
                displayType='text'
                value={total}
              />
            ),
          },
          {
            title: 'Realization',
            dataIndex: ['area'],
            align: 'right',
            width: 90,
            render: (val, record) => (
              <NumberColor
                target={record.target_area}
                realization={val}
              />
            ),
            // --------- summary ---------
            summaryKey: 'area',
            renderSummary: (total, _, summary) => !total ? '-' : (
              <NumberColor
                target={summary.target_area}
                realization={total}
              />
            ),
          },
        ],
      },
    ]

    this.calculateColumnsWidth()
  }

  // --------- overridable ---------
  convertAnotherResponseData = () => null
  readProductionJobs = (opt) => readProductionJobs(opt)
  // renderSummaryTable = (currentData) => null
  getTableProps = () => null
  calculateColumnsWidth = () =>
    this._totalColumnsWidth = this.columns
      .reduce((acc, val) => acc.concat(val.children || val), [])
      .reduce((acc, val) => acc + (val.width || 60), 0)

  checkRange = (startDate, endDate) => (
    moment(endDate).diff(moment(startDate), 'month') <= 11
  )

  // getKey = (key) => key === 'range_after' ? 'date_after'
  //   : key === 'range_before' ? 'date_before'
  //   : key

  getParam = (key, val) => {
    if (key === 'range_before')
      return moment(this.range_before).startOf('month').format()
    if (key === 'range_after')
      return moment(this.range_after).endOf('month').format()
    if (key === 'user')
      return this.id

    return val
  }

  getMappedRecord = (monthlyWorkDay, record) => {
    record.days = monthlyWorkDay.total_day
    record.target_hour = (monthlyWorkDay.total_day * 8) - (record.day_off * 8)
    record.delta_hours = Number(lib.time.getFloat(record.ms)) - record.target_hour

    return record
  }

  _readProductionJobs = async () => {
    return new Promise((resolve, reject) => {
      request({
        urlKey: 'read-usersProductionJobs',
        data: {
          finished_date_after: moment(this.range_before).startOf('month').format(),
          finished_date_before: moment(this.range_after).endOf('month').format(),
          id: this.id,
          status: 'finished',
        },
        onSuccess: res => resolve(res.data),
        onFailed: reject,
      })
    })
  }

  readProductionTargetsCompany = async () => {
    return new Promise(async (resolve) => {
      const productionTargets = {}
      for (const dateMonth of this._dateMonths) {
        await request({
          urlKey: 'read-productionTargetsDashboard',
          data: { date: dateMonth },
          onSuccess: res => productionTargets[dateMonth] = res.data,
        })
      }

      resolve(productionTargets)
    })
  }

  readUserTypes = () => {
    return new Promise(async (resolve) => {
      const userTypes = {}
      for (const dateMonth of this._dateMonths) {
        await request({
          urlKey: 'read-userPointTypes',
          data: { id: this.id, date: dateMonth },
          onSuccess: res => userTypes[dateMonth] = res.data,
        })
      }

      resolve(userTypes)
    })
  }

  readUserTargets = async (date) => {
    return new Promise(async (resolve) => {
      const userTargets = {}
      for (const dateMonth of this._dateMonths) {
        await request({
          urlKey: 'read-productionTargetsUsers',
          data: { id: this.id, date: dateMonth },
          onSuccess: res => userTargets[dateMonth] = res.data,
        })
      }

      resolve(userTargets)
    })
  }

  readUserLeaves = async () => {
    console.log('readUserLeaves', this)
    return new Promise(async (resolve) => {
      request({
        urlKey: 'leave-user-leaves',
        data: {
          user: this.id,
          date_after: this._dateMonths[0],
          date_before: this._dateMonths.slice(-1)[0],
          view_mode: 'calendar',
          status: 'approved',
          source_type: 'user_apply',
        },
        onSuccess: res => resolve(res.data),
        onFailed: () => resolve([]),
      })
    })
  }

  readMonthlyWorkDays = async () => {
    return new Promise((resolve) => {
      request({
        urlKey: 'office-working-sheet',
        data: {
          date_before: this._dateMonths[0],
          date_after: this._dateMonths.slice(-1)[0],
        },
        onSuccess: res => resolve(res.data),
        onFailed: () => resolve([]),
      })
    })
  }

  doReadAnother = async () => {
    return new Promise(async (resolve) => {
      const date = moment(this.range_before).startOf('month')
      const totalMonths = moment(this.range_after).startOf('month').add(1, 'month').diff(date, 'month')
      console.log('totalMonths', totalMonths)
      this._dateMonths = []
      for (let i = 0; i < totalMonths; i += 1)
        this._dateMonths.push(moment(date).add(i, 'month').format('YYYY-MM-DD'))

      const productionJobs = await this.readProductionJobs({ id: Number(this.id), date_after: this.range_before, date_before: this.range_after }).catch(error => null)
      const productionTargets = await this.readProductionTargetsCompany()
      const userTypes = await this.readUserTypes()
      const userTargets = await this.readUserTargets()
      const userLeaves = await this.readUserLeaves()
      const monthlyWorkDays = await this.readMonthlyWorkDays()

      console.log({ productionJobs, productionTargets, userTypes, userTargets, monthlyWorkDays })
      this._productionJobs = productionJobs
      this._productionTargets = productionTargets
      this._userTypes = userTypes
      this._userTargets = userTargets
      this._userLeaves = userLeaves
      this._monthlyWorkDays = monthlyWorkDays

      resolve()
    })
  }

  convertResponseData = (responseData) => {
    console.log('convertResponseData', {responseData, _userLeaves: this._userLeaves})

    const objActivities = groupBy(responseData, item => moment(item.start_time).format('YYYY-MM'))

    return this._dateMonths.map(dateMonth => {
      const month = moment(dateMonth).format('YYYY-MM')
      const currentMonthlyWorkday = this._monthlyWorkDays.find(monthlyWorkDay => moment(monthlyWorkDay.date).format('YYYY-MM') === month)
      const days = currentMonthlyWorkday
        ? currentMonthlyWorkday.total_day
        : get(this._productionTargets, [dateMonth, 'working_days'], 0)
      const activities = get(objActivities, [month], [])
      const ms = activities.reduce((acc, activity) => acc + lib.time.getDiff(activity), 0)
      const productionJobs = get(this._productionJobs, ['objQs', month], [])
      const point = productionJobs.reduce((acc, val) => acc + Number(val.qs_point), 0)
      const area = productionJobs.reduce((acc, val) => acc + Number(val.area), 0)
      const userTarget = this._userTargets[dateMonth]
      const pointTypes = get(this._userTypes[dateMonth], [0, 'point_types'], [])
      const pointTypeQS = pointTypes.find(type => typeCodes.QS_CODES.includes(type.code))
      const currentLeaves = submissionHelper._leave.getLeaves(month, this._userLeaves, submissionHelper._s.F_MONTH)
      const totalLeavesDay = Math.abs(submissionHelper._leave.getTaken(currentLeaves))
      const convertedOvertimes = currentLeaves.reduce((acc, val) => acc.concat(val.converted_overtimes), [])
      const totalOvertimesDay = convertedOvertimes.reduce((acc, val) => acc + val.balance_history.day_count, 0)
      const dayOff = totalLeavesDay - totalOvertimesDay
      const targetHour = days
        ? (days * 8) - (dayOff * 8)
        : 0

      return ({
        date: dateMonth,
        days,
        days_production: get(this._productionTargets, [dateMonth, 'working_days'], 0),
        overtime_day: totalOvertimesDay,
        day_off: dayOff,
        // target_hour: days * 8 || '-',
        target_hour: targetHour,
        delta_hours: Number(lib.time.getFloat(ms)) - targetHour,
        activities,
        ms,
        target_area: days * 8 * 40,
        area,
        target_kpi: 40, // static for now
        kpi: !ms ? 0 : Math.round(area / Number(lib.time.getFloat(ms))),
        target_point: (days && pointTypeQS && get(userTarget, [0, 'target', 'amount']))
          ? days / 20 * (lib.prod.getUserAmount(userTarget[0].target.amount) / pointTypeQS.denominator)
          : 0,
        point,
        ...this.convertAnotherResponseData(responseData, dateMonth),
      })
    })
  }

  getFilterInput = () => (
    <Col className='only-xs-block'>
      <Row gutter={[6, 6]}>
        <Col className='only-xs-block'>
          <DatePicker.RangePicker
            allowClear={false}
            picker='month'
            ranges={{
              'Last Year': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
              'This Year': [moment().startOf('year'), moment().endOf('year')],
            }}
            style={{ width: '100%' }}
            defaultValue={[moment(this.range_before), moment(this.range_after)]}
            onChange={(dates, dateStrings) => {
              this.tempDateStrings = dateStrings
            }}
            onOpenChange={(opened) => {
              if (!opened) {
                if (this.tempDateStrings[0] !== this.range_before || this.tempDateStrings[1] !== this.range_after)
                  this.onChangeFilter({ start_date: this.tempDateStrings[0], end_date: this.tempDateStrings[1] })
              } else {
                this.tempDateStrings = [this.range_before, this.range_after]
              }
            }}
            />
        </Col>
      </Row>
    </Col>
  )

  getDateRangeContent = () => (
    <Col style={{ padding: '6px 12px' }}>
      <div style={{ fontSize: '12px', color: '#cdcdcd' }}>
        Selected Range
      </div>
      <div style={{ fontSize: '18px', fontWeight: 500 }}>
        {moment(this.range_before).format('MMM')}
        {' – '}
        {moment(this.range_after).format('MMM YYYY')}
      </div>
    </Col>
  )

  renderSummaryTable = (currentData) => {
    const summary = {}
    let summaryKeys = []
    for (const column of this.columns) {
      summaryKeys.push(column.summaryKey)

      // hanya mendukung 1 child level
      for (const childColumn of (column.children || []))
        summaryKeys.push(childColumn.summaryKey)
    }
    summaryKeys = summaryKeys.filter(v => v)// = this.columns.map(column => column.summaryKey || (column.children)).filter(val => val)
    for (const record of currentData) {
      for (const summaryKey of summaryKeys) {
        summary[summaryKey] = (summary[summaryKey] || 0) + (record[summaryKey] || 0)
      }
    }

    const columns = this.columns.reduce((acc, column) =>
      acc.concat(...(column.children ? column.children : [column])), [])

    return (
      <Table.Summary>
        <Table.Summary.Row style={{ borderTop: '1px solid black' }}>
          {columns.map((column, i) => (
            <Table.Summary.Cell
              key={column.dataIndex + column.title}
              index={i}
              align="right"
              className="summary-cell-border"
              {...column.summaryProps}
            >
              {column.renderSummary && column.renderSummary(summary[column.summaryKey], currentData, summary)}
            </Table.Summary.Cell>
          ))}
        </Table.Summary.Row>
      </Table.Summary>
    )
  }

  renderExtraTitle = () => null

  getBodyContent = () => {
    console.log('Rendered', this)
    const selectedUsers = this.getSelectedUsers()

    return (
      <div>
        <div>
          {selectedUsers.length > 0 && (
            <Collapse activeKey={selectedUsers.map(user => user.alias)}>
              {selectedUsers.map(user => (
                <Collapse.Panel key={user.alias} header={this.getUserTitle(user)} className='panel-report'>
                  <Row justify='space-between'>
                    <Col>
                      <Row align="middle">
                        <Col>
                          <div style={{ display: 'flex', fontSize: '20px', padding: '12px' }}>
                            Average KPI / Year:
                            <Tooltip placement="right" mouseLeaveDelay={0} title="Total KPI / Total Months in parameter" overlayStyle={{ maxWidth: '280px' }}>
                              <b style={{ marginLeft: '4px' }}>
                                {(this.__list.reduce((acc, val) => acc + val.kpi, 0) / this.__list.length).toFixed(2)}
                              </b>
                            </Tooltip>
                          </div>
                        </Col>
                        <Col>
                          {this.renderExtraTitle()}
                        </Col>
                      </Row>
                    </Col>
                    {!this.mutableScreen.isMobile && this.getDateRangeContent()}
                  </Row>
                  <Table
                    bordered
                    size='small'
                    columns={this.columns}
                    dataSource={this.__list}
                    pagination={false}
                    rowKey='date'
                    // scroll={this.scrollConfig}
                    scroll={{ x: this._totalColumnsWidth }}
                    className="table-even-odd"
                    summary={this.renderSummaryTable}
                    {...this.getTableProps()}
                  />
                </Collapse.Panel>
              ))}
            </Collapse>
          )}
        </div>
      </div>
    )
  }
}

YearlyReport.propTypes = {
  ...YearlyReport.propTypes,
}

YearlyReport.defaultProps = {
  ...YearlyReport.defaultProps,
}

export default YearlyReport